import { useGlobals } from "@/components/providers/globals-provider.tsx";
import Button, { type ButtonProps } from "@/components/ui/button";
import Icon from "@/components/ui/icon";
import useModelCode from "@/features/sub-families/hooks/use-model-code.ts";
import useTracking from "@/features/tracking/hooks/use-tracking.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";

type Props = Omit<ButtonProps, "children" | "onClick">;
export default function InterestingProjects(props: Props) {
    const { navigation } = useGlobals();

    const t = useTranslations();
    const modelCode = useModelCode();
    const trackEvent = useTracking();

    if (!navigation?.projectsUrl) return null;

    const trackInterestingProjects = () => {
        trackEvent("3d-nav-projects", {
            component: "navigation",
            label: "interesting_projects",
            model_code: modelCode ?? "",
        });
    };

    return (
        <Button {...props} variant="action" background="dark" onClick={trackInterestingProjects} asChild>
            <a href={navigation.projectsUrl}>
                <span>{t("interesting_projects")}</span>
                <Icon name="show" />
            </a>
        </Button>
    );
}
